import React from 'react';
// import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
// import Box from "@material-ui/core/Box";


export default function NotAvailability(props) {

    return (
        <React.Fragment>
            <div>
            {/* <Paper elevation={0}> */}
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={2}
                >
                    <Grid item xs>
                        {props.AgenciaWeb === "Ibero" ? (
                            <img src={"/Images/Logo-Iberoluna-2.png"} width="230px" alt="Logo"></img>
                        ) : (
                            <fragment></fragment>
                        )}
                        {props.AgenciaWeb === "MC" ? (
                            <img src={"/Images/logoMC1.png"} width="230px" alt="Logo"></img>
                        ) : (
                            <fragment></fragment>
                        )}
                        {props.AgenciaWeb === "undefined" || props.AgenciaWeb === "Atom" || props.AgenciaWeb === null ? (
                            <img src={"/Images/logoAtom.png"} width="150px" alt="Logo"></img>
                        ) : (
                            <fragment></fragment>
                        )}
                    </Grid>
                    {/* <Grid item xs> */}
                    <Typography variant="h6" gutterBottom>
                                  No hemos conseguido disponibilidad.
                        </Typography>
                 {/*    <Typography variant="h6" gutterBottom>
                        <span><img src={props.countryFlag} width="20px" alt="País"></img></span> {props.zoneName}
                    </Typography> */}
                {/*     <Typography  variant="subtitle1" gutterBottom>
                        No hemos conseguido disponibilidad.
                        </Typography> */}
                    <Typography  variant="subtitle1" gutterBottom>
                        Favor ajustes los criterios de busqueda.
                        </Typography>
                    {/* </Grid> */}

                </Grid>
            {/* </Paper> */}
            </div>
        </React.Fragment>
    );
}
